import { createReducer } from "redux-create-reducer";
import { UI_ACTIONS } from "./uiActions";
import { REHYDRATE } from "redux-persist/constants";
const VERSION = 1;
const INITIAL_STATE = {
    version: VERSION,
    isActiveModal: false,
    triggerId: "",
    modalId: ""
};
/**
 * Reducer creation and export.
 * Uses the constants above to define new state for each action;
 */
export default createReducer(INITIAL_STATE, {
    /* --- Modal status --- */
    [UI_ACTIONS.MODAL_OPEN](state, action) {
        return {
            ...state,
            isActiveModal: true,
            triggerId: action.payload.triggerId || "",
            modalId: action.payload.modalId
        };
    },
    [UI_ACTIONS.MODAL_CLOSE](state, action) {
        return {
            ...state,
            isActiveModal: false,
            triggerId: action.payload.triggerId || "",
            modalId: action.payload.modalId
        };
    },
    [REHYDRATE](state, action) {
        const { ui } = action.payload;
        if (ui == null || ui.version !== VERSION || ui.modalId === "sessionTimeout") {
            return { ...state };
        }
        return {
            ...state,
            ...ui
        };
    }
});



// WEBPACK FOOTER //
// ./src/assets/scripts/domain/ui/uiReducer.ts